/**
 * Strip one-time credentials (OAuth `code`/`state`, reset/verify `token`,
 * invite secrets) from a URL before it is persisted or sent anywhere.
 *
 * Audit Low (2026-09-17): crash telemetry shipped `window.location.href`
 * verbatim and the freeze-recorder persisted `pathname + search` to
 * localStorage — both could park a live one-time token outside the address bar.
 *
 * @param href - A URL string (absolute or path+query).
 * @returns The URL with the VALUES of sensitive query params replaced by
 *   `<redacted>`; param names and all other params are preserved.
 */
export function redactUrl(href: string): string {
  return href.replace(/([?&](?:code|state|token|secret|key|ticket))=[^&]*/gi, '$1=<redacted>')
}
